[
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
    "moduleAssignmentName": "Rukagen Objection Handling",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "inProgressUsersCount": 21,
    "assignedUsersCount": 15,
    "proficientUsersCount": 18,
    "scoreCriteria": 1.0,
    "category": "RECENT_ASSIGNMENTS",
    "teamUuids": [
      "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a",
      "5d6e7f8a-9b2c-4d8f-92e5-3b7e8c9f0a4b"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afb",
    "moduleAssignmentName": "Rukagen Treatment Strategy Role Play",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "category": "RECENT_ASSIGNMENTS",
    "inProgressUsersCount": 11,
    "assignedUsersCount": 3,
    "proficientUsersCount": 40,
    "scoreCriteria": 1.0,
    "teamUuids": [
      "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
      "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afa",
    "moduleAssignmentName": "Rukagen Visual Aid Practice",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "category": "RECENT_ASSIGNMENTS",
    "inProgressUsersCount": 8,
    "assignedUsersCount": 6,
    "proficientUsersCount": 40,
    "scoreCriteria": 1.0,
    "teamUuids": [
      "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
      "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afd",
    "moduleAssignmentName": "Rukagen Value Proposition",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "category": "RECENT_ASSIGNMENTS",
    "inProgressUsersCount": 2,
    "assignedUsersCount": 5,
    "proficientUsersCount": 47,
    "scoreCriteria": 1.0,
    "teamUuids": [
      "2c3d4e5f-6a7b-8c9d-97e0-8a2b3c4d5e9f",
      "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
    "moduleAssignmentName": "Rukagen Objection Handling",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "inProgressUsersCount": 21,
    "assignedUsersCount": 15,
    "proficientUsersCount": 18,
    "scoreCriteria": 1.0,
    "category": "ALL_ASSIGNMENTS",
    "teamUuids": [
      "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a",
      "5d6e7f8a-9b2c-4d8f-92e5-3b7e8c9f0a4b"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afb",
    "moduleAssignmentName": "Rukagen Treatment Strategy Role Play",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "category": "ALL_ASSIGNMENTS",
    "inProgressUsersCount": 11,
    "assignedUsersCount": 3,
    "proficientUsersCount": 40,
    "scoreCriteria": 1.0,
    "teamUuids": [
      "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
      "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afa",
    "moduleAssignmentName": "Rukagen Visual Aid Practice",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "category": "ALL_ASSIGNMENTS",
    "inProgressUsersCount": 8,
    "assignedUsersCount": 6,
    "proficientUsersCount": 40,
    "scoreCriteria": 1.0,
    "teamUuids": [
      "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
      "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afd",
    "moduleAssignmentName": "Rukagen Value Proposition",
    "startDate": "Today - 15 days",
    "endDate": "Today + 15 days",
    "category": "ALL_ASSIGNMENTS",
    "inProgressUsersCount": 2,
    "assignedUsersCount": 5,
    "proficientUsersCount": 47,
    "scoreCriteria": 1.0,
    "teamUuids": [
      "2c3d4e5f-6a7b-8c9d-97e0-8a2b3c4d5e9f",
      "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a"
    ]
  }
]
